'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_scm_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bF)));
}
export { $is_scm_Set as $is_scm_Set };
function $isArrayOf_scm_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bF)));
}
export { $isArrayOf_scm_Set as $isArrayOf_scm_Set };
